module.exports = __webpack_public_path__ + "static/media/TikTok__1.05b9ce43.mp4";